import { AccountsPageContent } from '../components/AccountsPageContent'

export function AccountsPage() {
  return (
    <section className="cp-page cp-accounts">
      <AccountsPageContent />
    </section>
  )
}
